export class NeptuneClusterParameterGroups {
    'parameterGroups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "parameterGroups",
            "baseName": "parameterGroups",
            "type": "Array<NeptuneClusterParameterGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NeptuneClusterParameterGroups.attributeTypeMap;
    }
    constructor() {
    }
}
